import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types'; // ES6
import { Input, Button } from 'antd';

import { inserirComentariAvis, avisVisualitzacioModificarTextNouComentari } from '../../actions';
import { selectorLogin } from '../../selectors/selector_login';

const { TextArea } = Input;

class AvisInformacioAddicionalComentarisInserir extends Component {

    constructor(props) {
        super(props);

        this.onClickBotoInserirComentari = this.onClickBotoInserirComentari.bind(this);
        this.modificarComentari = this.modificarComentari.bind(this);
    }

    modificarComentari(valorTextArea) {
        this.props.avisVisualitzacioModificarTextNouComentari(valorTextArea);
    }

    onClickBotoInserirComentari() {
        const { idUsuari, textComentari } = this.props;

        // només s'envia si hi ha text a l'input
        if (textComentari.length > 0) {
            this.props.inserirComentariAvis(idUsuari, textComentari);
        }
    }

    render() {
        const { textComentari, inserintComentari } = this.props;

        return (
            <div className='avis-informacio-addicional-comentaris-inserir'>
                <div className='avis-informacio-addicional-comentaris-inserir-textarea'>
                    <TextArea
                        autosize={{ minRows: 2, maxRows: 1 }}
                        placeholder='Escriu un comentari'
                        onChange={(event) => this.modificarComentari(event.target.value)}
                        value={textComentari} />
                </div>
                <div className='avis-informacio-addicional-comentaris-inserir-boto'>
                    <Button
                        type='primary'
                        icon='plus'
                        shape="circle"
                        loading={inserintComentari}
                        onClick={this.onClickBotoInserirComentari}>
                    </Button>
                </div>
            </div>
        );
    }
}

AvisInformacioAddicionalComentarisInserir.propTypes = {
    idUsuari: PropTypes.number,
    inserintComentari: PropTypes.bool,
    textComentari: PropTypes.string,
    inserirComentariAvis: PropTypes.func,
    avisVisualitzacioModificarTextNouComentari: PropTypes.func
};

const mapStateToProps = (state) => {
    return {
        idUsuari: selectorLogin(state).idUsuari,
        textComentari: state.avis.visualitzacio.comentaris.textNouComentari,
        inserintComentari: state.avis.visualitzacio.comentaris.peticioInserirEnCurs
    };
};

export default connect(mapStateToProps, {inserirComentariAvis, avisVisualitzacioModificarTextNouComentari})(AvisInformacioAddicionalComentarisInserir);



// WEBPACK FOOTER //
// ./src/components/avis/avisInformacioAddicionalComentarisInserir.js